import { getComponentByType } from './ComponentPicker/componentTypes';
import BaseComponent from './IdeaComponents/BaseComponent';

const DefaultComponent = ({ component }) => (
  <BaseComponent
    component={component}
    isOwner={false}
    icon={getComponentByType(component.type)?.icon || <></>}
  >
    <div className="p-4">
      <h3 className="font-medium text-[var(--text-primary)] mb-3 text-lg">
        {component.title || `Unsupported Component: ${component.type}`}
      </h3>
      <pre className="text-xs text-[var(--text-secondary)]">
        {JSON.stringify(component.data, null, 2)}
      </pre>
    </div>
  </BaseComponent>
);

export default function ComponentLoader({ component, onUpdate, onDelete, isOwner, refreshSidebar, onReorder }) {
  const componentType = getComponentByType(component.type);
  
  if (!componentType) {
    return <DefaultComponent component={component} />;
  }

  const SpecificComponent = componentType.component;
  const disclaimer = componentType.aiExcluded ? "The project AI has limited or no access to this component's data." : null;
  
  return (
    <BaseComponent
      component={component}
      onUpdate={onUpdate}
      onDelete={onDelete}
      isOwner={isOwner}
      icon={componentType.icon}
      disclaimer={disclaimer}
      onReorder={onReorder}
    >
      <SpecificComponent 
        component={component}
        onUpdate={onUpdate}
        refreshSidebar={refreshSidebar}
      />
    </BaseComponent>
  );
}